const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const dateTimeFormat = (dateTime) =>{
    const dateObj = new Date(dateTime.replace(/(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1-$2-$3T$4:$5:$6'));
    const year = `${dateObj.getFullYear()}`
    const formattedDateTime = `${dateObj.getDate()} ${months[dateObj.getMonth()]} ’${year.slice(-2)}`;
    return formattedDateTime;
}

export const formatDateMonthYear = (dateStr, dateFormat="DD-MM-YYYY") => {
    const [year, month, day] = dateStr.split("-"); // Split the date
    const dateInNumericFormat = `${day}-${month}-${year}`; // DD-MM-YYYY format
    const dateWithMonthName = `${day}-${months[parseInt(month) - 1]}-${year}`; // DD-MonthName-YYYY format
    if(dateFormat === "DD-MM-YYYY"){
        return dateInNumericFormat;
    }else if(dateFormat === "DD-MonthName-YYYY"){
        return dateWithMonthName;
    }
}

export const formatEnteredDate = (entered_date, withTime = false) => {
  if (!entered_date) return "";

  // Accept strings like "03-10-2025 13:35:06 +0000"
  const parts = entered_date.trim().split(/\s+/);
  const datePart = parts[0];            // "03-10-2025"
  const timePart = parts[1] || "00:00:00"; // "13:35:06" (ignore timezone part)

  const [d, m, y] = datePart.split("-").map(Number);
  if (!d || !m || !y) return entered_date; // fallback if input unexpected

  const [hh = 0, mm = 0] = (timePart.split(":").map(n => parseInt(n, 10)));

  const dayStr = String(d).padStart(2, "0");
  const yearShort = String(y).slice(-2);
  const formattedDate = `${dayStr} ${months[m - 1]}'${yearShort}`;

  if (!withTime) return formattedDate;

  // 24 -> 12 hour conversion (no zero-pad on hour)
  let hour12 = hh % 12;
  if (hour12 === 0) hour12 = 12;
  const ampm = hh < 12 ? "AM" : "PM";
  const minuteStr = String(mm).padStart(2, "0");

  return `${formattedDate} ${hour12}:${minuteStr}${ampm}`;
};